@if (isCheckUser() && sideNav) {
<app-side-nav (onToggleSideNav)="onToggleSideNav($event)"></app-side-nav>
}
@if (isCheckUser() && producerHeader) {
<app-producer-header></app-producer-header>
}
@if (isCheckUser() && groupHeader) {
<app-group-header></app-group-header>
}
@if (isCheckUser() && GroupCoordinatorHeader) {
<app-co-ordinator-header></app-co-ordinator-header>
}@if (isCheckUser() && TracerHeader) {
<app-tracer-header></app-tracer-header>
}
@if (isCheckUser() && consumerHeader) {
<app-consumer-header></app-consumer-header>
}
<app-body [collapsed]="isSidenavCollapsed" [screenWidth]="screenWidth">
</app-body>